import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Container from 'base-ui/dist/Container';
import { fetchMenu } from 'state/slices/menus';
import Menu from './Menu';

const MenuDesktop = () => {
  const dispatch = useDispatch();
  const { items: { main = [] } } = useSelector((state) => state.menus);

  useEffect(() => {
    dispatch(fetchMenu('main'));
  }, []);

  return (
    <nav id="menu">
      <Container fluid wrap>
        <Menu items={main} />
      </Container>
    </nav>
  );
};

export default MenuDesktop;
